module.exports = __webpack_public_path__ + "img/packetgrup-large.d59ae73d.webp";